/**
 * Central brand constants for CitizenShipper.
 * Update values here to propagate across the entire site.
 */

// Contact
export const SUPPORT_EMAIL = "support@citizenshipper.com"
export const ADDRESS_LINE_1 = "701 Tillery Street Unit 12-1249"
export const ADDRESS_LINE_2 = "Austin, Texas 78702"

// Legal
export const TERMS_OF_SERVICE_URL =
  "https://help.citizenshipper.com/hc/en-us/categories/200277749-Terms-of-Service-Agreements"
export const PRIVACY_POLICY_URL =
  "https://help.citizenshipper.com/hc/en-us/articles/204865815-Privacy-policy"
// Build year from next.config.js `env`. Reading the clock at render time
// breaks hydration when server and browser disagree on the year (MAR-101).
// The clock fallback only runs outside Next builds, such as Vitest.
export const COPYRIGHT_YEAR =
  process.env.NEXT_PUBLIC_BUILD_YEAR ?? String(new Date().getFullYear())

// Logo
export const LOGO_URL = "https://citizenshipper.com/icons/cs-logo-name.svg"

// Social media
export const FACEBOOK_URL = "https://www.facebook.com/CitizenShipperLLC/"
export const TWITTER_URL = "https://x.com/CitizenShipper"
export const LINKEDIN_URL = "https://www.linkedin.com/company/citizenshipper"
export const INSTAGRAM_URL = "https://www.instagram.com/citizenshipper/"
export const GOOGLE_MAPS_URL = "https://maps.app.goo.gl/JCfqmdmvw9RQjKym9"
export const GOOGLE_SEARCH_PROFILE_URL =
  "https://profile.google.com/cp/CgsvbS8wMTExOThxNA=="
export const TIKTOK_URL = "https://www.tiktok.com/@citizen.shipper"
export const YOUTUBE_URL = "https://www.youtube.com/@citizenshipper"
export const PINTEREST_URL = "https://www.pinterest.com/citizenshipper/"
export const REDDIT_URL = "https://www.reddit.com/r/Citizen_Shipper/"
// Review & directory profiles
export const TRUSTPILOT_URL =
  "https://www.trustpilot.com/review/citizenshipper.com"
export const TRUSTPILOT_REVIEWS_URL = `${TRUSTPILOT_URL}?stars=5#:~:text=Reply%20from%20CitizenShipper`
export const BBB_URL =
  "https://www.bbb.org/us/tx/austin/profile/delivery-service/citizen-shipper-0825-1000131839"
export const CRUNCHBASE_URL =
  "https://www.crunchbase.com/organization/citizenshipper"
export const CONSUMERAFFAIRS_URL =
  "https://www.consumeraffairs.com/pets/citizenshipper.html"
export const WIKIPEDIA_URL = "https://en.wikipedia.org/wiki/CitizenShipper"

export const FOUNDING_YEAR = 2008

export function yearsSinceFounding(now: Date = new Date()): number {
  return now.getUTCFullYear() - FOUNDING_YEAR
}
